var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:("anx-table-col text-" + _vm.align)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }